import React from "react";
import { object, arrayOf, shape, string, func, bool, any } from "prop-types";
import { connect } from "react-redux";
import { markDocumentReadKingspan } from "../redux/actions";
import Onboarding from "../components/Kingspan/KingspanOnboarding";
import { postSOPKingspan } from "../redux/actions/kingspanActions";

const KingspanOnboardingContainer = ({
  readingListDownloads,
  kingspanOnboarding,
  markDocumentReadFunc,
  SOPDocsLine1,
  SOPDocsLine24,
  SOPDocsLine3,
  SOPDocsShop1,
  postSOPKingspanFunc,
  kingspanReadingLoading,
  SOPLoading,
}) => {
  return (
    <Onboarding
      readingList={readingListDownloads}
      kingspanOnboarding={kingspanOnboarding}
      markDocumentRead={markDocumentReadFunc}
      SOPDocsLine1={SOPDocsLine1}
      SOPDocsLine24={SOPDocsLine24}
      SOPDocsLine3={SOPDocsLine3}
      SOPDocsShop1={SOPDocsShop1}
      postSOPKingspan={postSOPKingspanFunc}
      kingspanReadingLoading={kingspanReadingLoading}
      SOPLoading={SOPLoading}
    />
  );
};

KingspanOnboardingContainer.propTypes = {
  markDocumentReadFunc: func.isRequired,
  kingspanOnboarding: object,
  readingListDownloads: arrayOf(
    shape({
      title: string.isRequired,
      link: string.isRequired,
    })
  ),
  SOPDocsLine1: arrayOf(
    shape({
      title: string.isRequired,
      link: string.isRequired,
    })
  ),
  SOPDocsLine24: arrayOf(
    shape({
      title: string.isRequired,
      link: string.isRequired,
    })
  ),
  SOPDocsLine3: arrayOf(
    shape({
      title: string.isRequired,
      link: string.isRequired,
    })
  ),
  SOPDocsShop1: arrayOf(
    shape({
      title: string.isRequired,
      link: string.isRequired,
    })
  ),
  postSOPKingspanFunc: func.isRequired,
  kingspanReadingLoading: bool,
  SOPLoading: string,
};

const mapStateToProps = (state) => ({
  readingListDownloads: state.core.umbracoContent.kingspanReadingList,
  SOPDocsLine1: state.core.umbracoContent.SOPDocsLine1,
  SOPDocsLine24: state.core.umbracoContent.SOPDocsLine24,
  SOPDocsLine3: state.core.umbracoContent.SOPDocsLine3,
  SOPDocsShop1: state.core.umbracoContent.SOPDocsShop1,
  kingspanOnboarding: state.core.app.kingspanOnboarding,
  kingspanReadingLoading: state.core.kingspanReading.isLoading,
  SOPLoading: state.core.kingspanSOP.formName,
});

const mapDispatchToProps = {
  markDocumentReadFunc: markDocumentReadKingspan,
  postSOPKingspanFunc: postSOPKingspan,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(KingspanOnboardingContainer);
